export const CHART_COLOR_BPM = "#9B141A";
export const CHART_COLOR_SPEED = "#5BC0DE";
export const CHART_COLOR_STRIDE_LENGTH = "#8FB62A";
export const CHART_COLOR_STRIDE_FREQUENCY = "rgb(188, 116, 33)";

export const CHART_COLOR_BPM_WITH_OPACITY = (opacity: number = 1) => {
    return `rgba(155, 20, 26, ${opacity})`
}